import React from "react";

export default function HousingVideos() {
  return (
    <div>
      <HousingVideo
        textPosition="right"
        embedUrl="https://www.youtube.com/embed/yp1g_GbxufA"
        title="Potter Hall"
        text="Cookie and T.R. Jr. Potter Hall is a co-ed facility housing 248 students and has a private bathroom in each residential room."
      />
      <HousingVideo
        textPosition="left"
        embedUrl="https://www.youtube.com/embed/uf661Mf4gJY"
        title="Mouton Hall"
        text="Mouton Hall has the capacity to house 147 students. Each floor has a large lounge and laundry facility."
      />
      <HousingVideo
        textPosition="right"
        embedUrl="https://www.youtube.com/embed/wk8RvoBt4bQ"
        title="Hilltop Apartments"
        text="As a Maryville upperclassman, you want the convenience that living on campus provides, but you also crave the independent living experience. You can do both!"
      />
      <HousingVideo
        textPosition="left"
        embedUrl="https://www.youtube.com/embed/jJu7GzfMY7U"
        title="Saints Hall"
        text="Saints Hall, the University's newest residence hall is yet another indication of Maryville University's tremendous growth, and our strong commitment to providing a vibrant student-centered campus experience. Saints Hall features a fitness center, open lobby and lounge spaces and a modern floor plan."
      />
    </div>
  );
}

function HousingVideo({ textPosition, embedUrl, title, text }) {
  return (
    <div className="flex flex-wrap mb-4">
      <div
        className={`w-full md:w-1/2 p-4 ${
          textPosition === "left" ? "md:text-right" : "md:order-1"
        }`}
      >
        <h3 className="font-bold text-xl uppercase mb-8">{title}</h3>
        <p className="text-gray">{text}</p>
      </div>
      <div className="w-full md:w-1/2  p-4">
        <div className="relative h-0" style={{ paddingBottom: "56.25%" }}>
          <iframe
            width="100%"
            height="100%"
            top="0"
            left="0"
            style={{ position: "absolute" }}
            src={embedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title={title}
          ></iframe>
        </div>
      </div>
    </div>
  );
}
